<template>
  <div class="section-wrapper btn-radius relative">
    <div class="controls invisible absolute -mt-13" v-if="!isPreview">
      <div
        class="text-grey-500 bg-grey-900 rounded-lg btn-radius px-4 py-3 flex"
      >
        <div
          class="h-5 w-5 cursor-pointer justify-center items-center mr-7"
          :class="[index > 0 ? 'flex' : 'hidden']"
          @click="moveSection(index, index - 1)"
        >
          <arrowUpIcon />
        </div>
        <div
          class="h-5 w-5 cursor-pointer justify-center items-center mr-7"
          :class="[length - 1 !== index ? 'flex' : 'hidden']"
          @click="moveSection(index, index + 1)"
        >
          <arrowDownIcon />
        </div>
        <div
          class="h-5 w-5 cursor-pointer flex justify-center items-center mr-7"
          @click="cloneSection(index)"
        >
          <cloneIcon />
        </div>
        <div
          @click="openDeleteSectionConfirmationBox(index)"
          class="h-5 w-5 cursor-pointer flex justify-center items-center"
        >
          <deleteIcon />
        </div>
      </div>
      <div class="pt-5"></div>
    </div>
    <div class="content w-full md:p-10 p-6 membership-content-section">
      <slot name="title"></slot>
      <slot name="content"></slot>
      <slot name="default"></slot>
    </div>
    <confirm-modal
      v-if="!isPreview"
      :callback="triggerDeleteSection"
      :ref="`confirmation-box-delete-${index}-section`"
      :name="`confirmation-box-delete-${index}-section`"
      :buttonText="'Delete'"
      :cancelText="'Cancel'"
      :confirm-message="'Are you sure you want to delete?'"
    />
  </div>
</template>
<script>
import ConfirmModal from '@groovepages/gd-ui-kit/components/ConfirmModal';
import arrowUpIcon from '../../../../../assets/images/icons/arrowup-icon.svg';
import arrowDownIcon from '../../../../../assets/images/icons/arrowdown-icon.svg';
import cloneIcon from '../../../../../assets/images/icons/clone-icon.svg';
import deleteIcon from '../../../../../assets/images/icons/delete-icon.svg';

export default {
  name: 'SectionWrapper',
  components: {
    ConfirmModal,
    arrowUpIcon,
    arrowDownIcon,
    cloneIcon,
    deleteIcon,
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    index: {},
    length: {},
    deleteSection: {
      type: Function,
      required: true,
    },
    moveSection: {
      type: Function,
      required: true,
    },
    cloneSection: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      sectionToDeleteIndex: -1,
    };
  },
  methods: {
    async triggerDeleteSection() {
      await this.deleteSection(this.sectionToDeleteIndex);
      this.sectionToDeleteIndex = -1;
    },
    openDeleteSectionConfirmationBox(index) {
      this.sectionToDeleteIndex = index;
      this.$refs[`confirmation-box-delete-${index}-section`].open();
    },
  },
};
</script>
<style lang="scss" scoped>
.section-wrapper:hover .controls {
  visibility: visible;
}
.membership-content-section {
  padding-left: 140px;
  padding-right: 140px;
  @media only screen and (max-width: 767px) {
    padding: 24px;
  }
}
</style>
